export type ColorOption = { bg: string; border: string };

export const colorOptions: ColorOption[] = [
    { bg: "#e0e7ff", border: "#a5b4fc" }, // scheduler default (indigo-100/300)
    { bg: "#eef2ff", border: "#818cf8" },
    { bg: "#c7d2fe", border: "#6366f1" },
    { bg: "#dbeafe", border: "#93c5fd" },
    { bg: "#eff6ff", border: "#60a5fa" },
];
